'use strict';

import { filter, find, uniqueId } from 'underscore';

import Level from "./FeedbackMessagesLevel";

import { flow, action, observable, configure, makeObservable } from "mobx";
configure({enforceActions: 'always'});

/**
 * This is the store for the FeedbackMessages component.
 */
class FeedbackMessagesStore {
    /**
     * Storage for messages at various levels.
     * @type {{success: [message, ...], warning: [message, ...], error: [message, ...], info: [message, ...]}}
     *
     * The form of a message object is ...
     *    {id: id, operation: "operationKey", text: "Some Text" }
     *
     * You can make up the operation key. This is used to clear the message for a particular operation.
     */
    messageMap = this._getEmptyMessageMap();

    constructor() {
        makeObservable(this, {
            messageMap: observable,
            clearMessage: action,
            addMessage: action,
            removeMessages: action
        });
    }

    /**
     * Clear the message identified by its operation key  - note that key identifies the message type,
     * while id identifies an individual message instance (we could potentially clear multiple messages with the same
     * key)
     */
    clearMessage(operation) {
        Object.keys(Level).forEach(function(key) {
            let messages = this.messageMap[key.toLowerCase()];
            this.messageMap[key.toLowerCase()] = filter(messages, function (item) {
                return item.operation !== operation
            });
        }, this);
    }

    /**
     * Adds a message to the message map at the given level.
     * @param message @type {level: "ERROR", operation: "SomeOperationIdentifier", text: "Some message"}
     */
    addMessage(message) {
        //  Make sure level is valid. Default to ERROR.
        let level = message.level;
        switch(level) {
            case Level.SUCCESS:
                break;
            case Level.INFO:
                break;
            case Level.WARNING:
                break;
            default:
               level = Level.ERROR;
        }

        /* Add the message to the message map if it doesn't already exist  */
        let existingValue = find(this.messageMap[level], function(item) {
            return item.text === message.text;
        });

        if (! existingValue) {
            let id = uniqueId();
            this.messageMap[level].push({
                id: id, operation: message.operation, text: message.text
            });
        }
    }

    /**
     * Remove all messages at the given level.
     * @param level
     */
    removeMessages(level) {
        if ( level ) {
            this.messageMap[level.toLowerCase()] = [];
        } else {
            this.messageMap = this._getEmptyMessageMap();
        }
    }

    /**
     * Gets an empty messageMap object
     * @return {{success: Array, warning: Array, error: Array, info: Array}}
     * @private
     */
    _getEmptyMessageMap() {
        return {
            success: [],
            info: [],
            warning: [],
            error: []
        };
    }
}

export default new FeedbackMessagesStore();